import type { TranslationF } from "@/utils/type-utils";
import { z } from "zod";

export const getRelationSchema = (t: TranslationF) =>
	z
		.object({
			maxDebt: z.preprocess(
				(v) => (v === "" || v == null ? null : Number(v)),
				z.number().nullable(),
			),
			useInheritedPrice: z.boolean().default(true),
			localPrice: z.preprocess(
				(v) => (v === "" || v == null ? null : Number(v)),
				z.number().nullable(),
			),
			isAllowToOrder: z.boolean().default(false),
		})
		.superRefine((data, context) => {
			if (!data.useInheritedPrice && data.localPrice === null) {
				context.addIssue({
					code: z.ZodIssueCode.custom,
					path: ["localPrice"],
					message: t("validation.required"),
				});
			}
		});

export type RelationFormData = z.infer<ReturnType<typeof getRelationSchema>>;

export type RelationInitialValues = {
	maxDebt: number | null;
	useInheritedPrice: boolean;
	localPrice: number | null;
	isAllowToOrder: boolean;
};
